// extracted by mini-css-extract-plugin
var _1 = "list__gJxKv";
var _2 = "list-column__d6L61";
export { _1 as "list", _2 as "listColumn" }
